import { Children } from 'react';

import type { ReactElement, ReactNode } from 'react';
import type { Step } from './Step';
import type { StepProps } from './useStepForm';

export type StepChild = ReactElement<StepProps, typeof Step>;

export type StepperProps = {
  /**
   * array of step ids that have been seen
   */
  history: string[];
  /**
   * steps to be rendered
   */
  children: StepChild | StepChild[] | null;
  /**
   * decorator function to customise how steps are rendered
   */
  render?: ({ children }: { children: StepChild | StepChild[] }) => ReactNode;
};

/**
 * Filters out children steps based on the history. If a render function is provided, it is applied to wrap steps before rendering.
 */
export const Stepper = ({ children, history, render }: StepperProps): JSX.Element => {
  const mappedChildren = (Children.toArray(children) as StepChild[]).filter((node) =>
    history.includes(node.props.id),
  );
  return <>{render ? render({ children: mappedChildren }) : mappedChildren}</>;
};
